"use client"
import React, { useState } from "react";

import "@/components/shared/CollapseText.css";

const CollapseText = ({ text, maxLength, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  if (text) {
    if (text.length <= maxLength) {
      return (
        <div className={`collapse-text ${className}`}>
          <span>{text}</span>
        </div>
      );
    } else {
      return (
        <div className={`collapse-text ${className}`}>
          <span className="text">
            {isExpanded ? text : `${text.substring(0, maxLength).trim()}...`}
          </span>
          <br />
          <button className="a" onClick={toggleExpanded}>
            {isExpanded ? "Show less" : "Show more"}
          </button>
        </div>
      );
    }
  } else {
    return <></>;
  }
};

export default CollapseText;
